import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractInput } from '@spaq/shared/components/forms/abstract-input';

@Component({
	selector: 'spaq-input-combo-box',
	template: `
		<kendo-formfield>
			<kendo-label [for]="formControlName" [text]="label"></kendo-label>
			<kendo-combobox
				class="w-100"
				#list
				(valueChange)="valueChanged.emit($event)"
				[valuePrimitive]="valuePrimitive"
				[id]="formControlName"
				[attr.data-testid]="dataTestId"
				[suggest]="false"
				[filterable]="filterable"
				[allowCustom]="allowCustom"
				[disabled]="disabled"
				[placeholder]="label"
				[textField]="textField"
				[valueField]="valueField"
				[contentEditable]="false"
				[(ngModel)]="value"
				(filterChange)="handleFilter($event)"
				(ngModelChange)="updateModel()"
				(blur)="onModelTouched && onModelTouched()"
				[data]="filteredData"
			>
				<ng-template kendoComboBoxItemTemplate let-dataItem>
					<span
						class="template"
						[id]="
							formControlName +
							'_' +
							((dataItem && dataItem[valueField] && dataItem[valueField].toString()) || dataItem.toString())
						"
						[attr.data-testid]="
							formControlName +
							'_' +
							((dataItem && dataItem[valueField] && dataItem[valueField].toString()) || dataItem.toString())
						"
						>{{ (dataItem && dataItem[textField]) || dataItem }}</span
					>
				</ng-template>
			</kendo-combobox>
		</kendo-formfield>
		<small class="alert-danger" *ngIf="control && (control.dirty || control.touched) && !isValid">Champs requis</small>
	`,
	styles: [
		`
			label {
				display: block;
				font-size: 11px;
			}
		`
	],
	providers: [
		{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InputComboBoxComponent), multi: true },
		{ provide: NG_VALIDATORS, useExisting: forwardRef(() => InputComboBoxComponent), multi: true }
	]
})
export class InputComboBoxComponent extends AbstractInput implements OnInit, OnChanges {
	@Input() allowCustom = false;
	@Input() data: Array<any> = [];
	@Input() enableOnChange = true;
	@Input() filterable = true;
	filteredData: Array<any> = [];
	@Input() label = '...';
	@ViewChild('list', { static: true }) list;
	@Output() valueChanged = new EventEmitter();
	@Input() textField = null;
	@Input() valueField = null;
	@Input() valuePrimitive = true;
	ngOnChanges() {
		if (this.enableOnChange) {
			this.filteredData = (this.data || []).slice();
		} else if (!this.filteredData.length) {
			this.filteredData = (this.data || []).slice();
		}
	}

	handleFilter(value) {
		this.filteredData = this.data.filter(s => {
			const val = !this.textField ? s : String(s[this.textField] || '');
			if (!s || s.length <= 1) {
				return true;
			}
			return val.toString().toLowerCase().indexOf(value.toLowerCase()) !== -1;
		});
	}
}
